export interface IDeliveryDriver {
  deliveryDriverId: number;
  name: string;
  vehicleRegNumber: string;
  vehicleType: VehicleType;
  contactNumber: string;
  altContactNumber: string;
}

export enum VehicleType {
  Car = 1,
  Bike = 2,
  Bicycle = 3,
}
